import { useMemo } from "react";

import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter";
import { useGetAllDealersForSelect } from "~/hooks/Selectors/useGetAllDealersForSelect";

/**
 * Адаптер `useGetAllDealersForSelect` под контракт `optionsHook` фильтра:
 * приводит value опций к строке (URL хранит строку).
 */
export const useDealerOptions = (): FilterFieldOptionsHookResult => {
  const { dealers, onScrollBottomDealers, searchDealer, loading } =
    useGetAllDealersForSelect({ searchDebounceMs: 400 });

  const options = useMemo<FilterFieldOption[]>(
    () =>
      dealers.map((option) => ({
        label: option.label,
        value: String(option.value),
      })),
    [dealers],
  );

  return {
    options,
    loading,
    onScrollBottom: onScrollBottomDealers,
    searchOptions: searchDealer,
  };
};
